import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecSatisfaction } from '../components/widgets/ExecSatisfaction';

export default function ExecSatisfactionPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="איכות שירות · דריל" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecSatisfaction />
        </main>
      </div>
    </div>
  );
}
